export default {
  introSteps: {
    exportFile: '別の Arena サーバー（例：Dev や QA）から調査をデータなしでエクスポートします',
    selectFile: 'エクスポートしたファイル（.zip）を選択します：この調査と比較され、差分が表示されます',
    applyChanges: '差分を確認し、選択した変更をこの調査に適用します（削除は既定では選択されません）',
    publish: '変更は下書きとして保存されます：フォームを確認し、調査を公開すると有効になります',
  },
  fileTooLarge:
    '選択したファイルが大きすぎます（最大 {{maxSize}} MB）：データなしで調査をエクスポートしてください。調査の比較にレコードとそのファイルは不要です',
  selectNewSource: '新しい比較元を選択',
  selectNewSourceInfo: 'この比較を破棄して、別の調査ファイルまたは調査を選択します',
  refreshComparison: '比較を更新',
  refreshComparisonInfo: '同じファイルをこの調査の現在のバージョンと再度比較します（例：編集後）',
  sourceSurvey: '比較した調査：{{name}}',
  compareWithSurvey: 'または、このサーバー上の別の調査と比較します：',
  fingerprint: {
    thisSurvey: 'この調査',
    comparedSurvey: '比較した調査',
    equal: 'この調査と同じ',
    different: 'この調査と異なる',
    label: 'フィンガープリント',
    structural: '構造',
    info: '調査定義（下書き）のフィンガープリントです。同じフィンガープリントは同じ定義を意味します。最初のものは内部 ID を含み、同じ調査のコピー（例：別のサーバーにエクスポートしてインポートしたもの）の場合のみ一致します。構造のものは名前とコードを使用し、同じ構造で別々に作成された調査でも一致します。名前、ラベル、ID、日付、公開状態は含まれません。',
    copy: 'フィンガープリント全体をコピー：{{value}}',
    copied: 'フィンガープリントをクリップボードにコピーしました',
  },
  identical: '調査は同一です',
  counts: '比較した調査のみ {{added}}、変更 {{changed}}、この調査のみ {{removed}}',
  surveyInfoChanged: '調査情報（言語、サイクル、ラベル）が異なります：「調査情報」タブを参照してください',
  onlyDifferences: '差分のみ表示',
  hideLayoutOnly: 'レイアウトのみの差分を非表示',
  apply: '選択した変更を適用（{{count}}）',
  applyConfirm: `選択した {{count}} 件の変更をこの調査に適用しますか？
変更は下書きとして保存され、調査を公開したときにのみレコードに反映されます。`,
  willBeDeleted: '削除されます',
  removedNodeDefInfo:
    'このノード定義はこの調査にのみ存在します：この変更を適用すると、この調査から（子孫とともに）削除されます。',
  removedItemInfo: 'この調査にのみ存在：この変更を適用すると、この調査から削除されます。',
  applyConfirmWithDeletionsHeader: '削除の確認',
  applyConfirmWithDeletions:
    '選択した{{count}}件の変更をこの調査に適用しますか？\n\n**そのうち{{deletionsCount}}件はこの調査の要素を削除します**（比較した調査にない要素）：\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: '適用して削除',
  confirmSurveyName: '確認のため、この調査の名前を入力してください：',
  deletionOfItemsOf: '**{{name}}** のこの調査にのみ存在する要素',
  moreDeletions: '... ほか{{count}}件',
  applyCompleted: '適用した変更：{{applied}}、スキップ：{{skipped}}。調査を公開すると有効になります。',
  tabs: {
    nodeDefs: 'ノード定義',
    categories: 'カテゴリ',
    taxonomies: '分類体系',
    surveyInfo: '調査情報',
    surveyFiles: 'ファイル',
  },
  status: {
    added: '比較した調査のみ',
    changed: '変更あり',
    removed: 'この調査のみ',
  },
  statusLabel: '状態',
  matchedBy: {
    uuid: '内部 ID で一致',
    name: '名前で一致（内部 ID が異なります）',
    manual: '手動で一致：名前変更として適用されます',
  },
  renameCandidate: 'この調査の「{{name}}」が名前変更されたものかもしれません',
  possibleRename: '名前変更の可能性',
  matchAsRename: '名前変更として一致させる',
  unmatch: '一致を取り消す',
  props: {
    branding: 'ブランディング',
    columnsNo: '列数',
    columnsOrder: '列の順序',
    cycles: 'サイクル',
    defaultCycleKey: '既定のサイクル',
    descriptions: '説明',
    extra: '追加プロパティ',
    family: '科',
    fieldManualLinks: 'フィールドマニュアルへのリンク',
    formLayout: 'フォームレイアウト',
    genus: '属',
    gridPosition: '行 {{row}}、列 {{column}}、幅 {{width}}、高さ {{height}}',
    itemExtraDef: '追加プロパティ',
    keepNonApplicableValues: '適用対象外の値を保持する',
    labels: 'ラベル',
    languages: '言語',
    layout: 'レイアウト',
    levels: 'レベル',
    messages: 'メッセージ',
    pagesOrder: 'ページの順序',
    parent: '親エンティティ',
    preloadedMapLayersEnabled: '事前読み込み地図レイヤーが有効',
    reportingData: 'レポートデータ',
    sampleBasedImageInterpretationEnabled: 'サンプルベースの画像判読',
    samplingPolygon: 'サンプリングポリゴン',
    scientificName: '学名',
    size: 'サイズ',
    srs: '空間参照系',
    surveyDocOptions: '調査ドキュメントのオプション',
    userExtraPropDefs: 'ユーザー追加プロパティ',
    validations: '検証',
    vernacularLanguageCodes: '通称名の言語',
    vernacularNames: '通称名',
  },
  fileTypes: {
    preloadedMapLayer: '事前読み込み地図レイヤー',
    surveyDocImage: '調査ドキュメントの画像',
    brandingSurveyLogo1: '調査ロゴ 1',
    brandingSurveyLogo2: '調査ロゴ 2',
    brandingSurveyLogo3: '調査ロゴ 3',
    brandingLandingBackground: 'ランディングページの背景',
  },
  cycle: 'サイクル {{cycle}}',
  property: 'プロパティ',
  sourceValue: '比較した調査',
  targetValue: 'この調査',
  emptyValue: '（空）',
  layoutOnly: 'レイアウトのみ',
  selectItem: '詳細を表示する項目を選択してください',
  noDifferences: '差分はありません',
  identicalItem: '差分はありません',
  dependsOn: '一緒に適用：',
  itemsCount: '項目：追加 {{added}}、変更 {{changed}}、この調査のみ {{removed}}',
  itemCode: 'コード',
  taxaCount: '分類群：追加 {{added}}、変更 {{changed}}、この調査のみ {{removed}}',
  taxonCode: 'コード',
  changes: '変更',
  moreItems: '…ほか {{count}} 項目',
  categoryRemoval: 'この調査にのみある項目（およびレベル）を削除',
  taxonomyRemoval: 'この調査にのみある分類群と通称名を削除',
  removalSelected: '削除を選択済み',
  publishedKept: '（公開済み：保持）',
  reasons: {
    categoryInUse: 'このカテゴリは削除されないノード定義で使用されています',
    categoryMissing: 'このカテゴリはこの調査にありません',
    cycleMissing: 'この調査にサイクルがありません',
    dependencyNotApplicable: '依存する変更が適用できません',
    parentMissing: '親ノード定義がこの調査にありません',
    publishedCategoryChanged: '公開済みのノード定義のカテゴリは変更できません',
    publishedKeyChanged: '公開済みのノード定義の「キー」プロパティは変更できません',
    publishedMoveNotSupported: '公開済みのノード定義は別のエンティティに移動できません',
    publishedMultipleChanged: '公開済みのノード定義の「複数」プロパティは変更できません',
    publishedTaxonomyChanged: '公開済みのノード定義の分類体系は変更できません',
    publishedTypeChanged: '公開済みのノード定義の型は変更できません',
    taxonomyInUse: 'この分類体系は削除されないノード定義で使用されています',
    taxonomyMissing: 'この分類体系はこの調査にありません',
    nodeDefUsedByOthers: '他のノード定義が式の中で使用しています：それらも更新してください',
    publishedCategoryItemsKept: '公開済みの項目は削除できません：保持されます',
    publishedCategoryLevelsKept: '公開済みのレベルは削除できません：保持されます',
    publishedCyclesRemoved: '公開済みのノード定義からサイクルを削除すると、そのサイクルのデータが削除されます',
    publishedLanguagesRemoved: '言語を削除すると、調査の公開時にそのラベルが削除されます',
    publishedNameChanged: '公開済みのノード定義の名前変更：古い名前を使用している式を更新する必要があります',
    publishedNodeDefDeleted: 'このノード定義は公開済みです：調査の公開時にそのデータが削除されます',
    publishedSurveyCyclesRemoved: 'サイクルを削除すると、調査の公開時にそのレコードが削除されます',
    publishedTaxaKept: '公開済みの分類群は削除できません：保持されます',
    publishedVernacularNamesKept: '公開済みの通称名は削除できません：保持されます',
  },
}
